module.exports = __webpack_public_path__ + "assets/img/step7.2742b904.jpg";